import { render, staticRenderFns } from "./livePage.vue?vue&type=template&id=425c0854&scoped=true&"
import script from "./livePage.vue?vue&type=script&lang=js&"
export * from "./livePage.vue?vue&type=script&lang=js&"
import style0 from "./livePage.vue?vue&type=style&index=0&id=425c0854&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425c0854",
  null
  
)

export default component.exports